module.exports = ".alert-text {\n  font-size: 14px;\n  color: #808080;\n  margin-top: 24px; }\n\n.mt40 {\n  margin-top: 40px; }\n\n.custom-divisor {\n  margin-top: 24px !important;\n  margin-bottom: 0px !important; }\n\n.has-error {\n  height: 50px !important; }\n\n.color-red {\n  color: #ef3232; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gto-finalizar/gto-finalizar.component.scss
// module id = ./src/app/components/gto-finalizar/gto-finalizar.component.scss
// module chunks = main